import { HttpUtils } from './Librairies/utils/httpUtils.js';
import { trackGoogleEvent } from './google-analytics.js';

const events = new Set(['service_view', 'diagnostic_click', 'form_success', 'phone_click']);

function send(event: string): void {
  if (!events.has(event)) {
    return;
  }

  HttpUtils.sendBeacon('/collect', {
    event,
    path: window.location.pathname
  });
  trackGoogleEvent(event);
}

export function initAnalytics(): void {
  if (document.querySelector('[data-service-page]')) {
    send('service_view');
  }

  if (document.querySelector('[data-form-success]')) {
    send('form_success');
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const link = target.closest('a');
    if (!link) {
      return;
    }

    const href = link.getAttribute('href') ?? '';
    if (href.includes('objet=diagnostic')) {
      send('diagnostic_click');
    } else if (href.startsWith('tel:')) {
      send('phone_click');
    }
  });
}
